export const rejectVehicleValidation = {
  reason: [{ required: true, message: 'Reason is required!' }],
};
